/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import * as React from "react";
import type { SVGIconProps } from "../../svgIconProps";
import { IconSize } from "../../iconTypes";
import { SVGIconContainer } from "../../svgIconContainer";

export const ArrowDown: React.FC<SVGIconProps> = React.forwardRef<any, SVGIconProps>(({size = IconSize.STANDARD, ...props}, ref) => {
    const isLarge = size! >= IconSize.LARGE;
    const pixelGridSize = isLarge ? IconSize.LARGE : IconSize.STANDARD;
    const translation = `${-1 * pixelGridSize / 0.014705882352941176 / 2}`;
    const style = { transformOrigin: "center" };
    return (
        <SVGIconContainer iconName="arrow-down" ref={ref} size={size} {...props}>
            <path
                d={isLarge ? "M887.7825 827.8575L680 620.075L472.2175 827.8575L418.795 774.435L653.2675 539.9625C668.0150000000001 525.2149999999999 691.9425000000001 525.2149999999999 706.6900000000002 539.9625L941.1625000000003 774.435L887.7400000000001 827.8574999999998z" : "M710.226 662.286L544 496.0599999999999L377.774 662.286L335.0360000000001 619.548L522.614 431.9699999999999C534.412 420.1719999999999 553.5540000000001 420.1719999999999 565.3520000000001 431.9699999999999L752.9300000000001 619.548L710.192 662.2859999999998z"}
                fillRule="evenodd"
                transform={`scale(0.014705882352941176, -0.014705882352941176) translate(${translation}, ${translation})`}
                style={style}
            />
        </SVGIconContainer>
   );
});
ArrowDown.displayName = `Blueprint5.Icon.ArrowDown`;
export default ArrowDown;
